import React from 'react'
import { connect } from 'umi';
// import RetentionUsers from '@/pages/dashboard/pages/engagement/retention/index';
import Nightingale from './nightingale';

const retentionIndex = (props: any) => {
  return (
    <>
      <Nightingale/>
    </>
  )

}

export default retentionIndex;
